<template>
  <div class="columns is-multiline">
    <div class="column is-full-mobile is-6">
      <basic></basic>
    </div>
    <div class="column is-full-mobile is-6">
      <events></events>
    </div>
    <div class="column is-full-mobile is-6">
      <geo-chart></geo-chart>
    </div>
    <div class="column is-full-mobile is-6">
      <sets></sets>
    </div>
  </div>
</template>


<script>
import Basic from './Basic.vue';
import Events from './Events.vue';
import GeoChart from './GeoChart.vue';
import Redraw from './Redraw.vue';
import Sets from './Sets.vue';

export default {
  components: {
    Basic,
    Events,
    GeoChart,
    Redraw,
    Sets,
  },
};
</script>
